/* eslint-disable */
import React from 'react';
import b from './devsBar.module.css';
import { Ic, Donut } from './devsIcons';
import { STAGES, fmt } from './devsBarModel';

// The Stage trigger (look C — a split chip with a ring of the six stage colours) and the tray of six
// full-name pills with live counts. The tray slides out to the right of the trigger in ONE move; the
// fit hook owns the move (measured widths, fold levels), React owns what is chosen.
// The stage Set is devFilters.status — the same Set the Flags group writes to (flags keep their own group).

export function StageTrigger({ open, chosen, onToggle }) {
  const sel = new Set(chosen), n = sel.size;
  const lbl = open ? 'Close stages' : n ? `Stages · ${n} chosen` : 'Stages';
  return (
    <button type="button" data-f="stt" data-fk="stt" className={`${b.stt} ${b.tC} ${open ? b.open : ''} ${n ? b.has : ''}`} aria-expanded={open} aria-controls="devs-sgb" aria-label={lbl} title={lbl} onClick={(e) => { e.stopPropagation(); onToggle(e); }}>
      <span className={b.dn} aria-hidden="true"><Donut stages={STAGES} sel={sel} /></span>
      <span className={`${b.cw} ${b.lbw}`} data-f="lbw"><span className={b.cn}><span className={b.lb}>Stages</span></span></span>
      {n ? <b className={b.bd}>{n}</b> : null}
      <Ic n="cvr" cls={b.cv} />
    </button>
  );
}

export function StageTray({ open, chosen, counts, ready, onToggle }) {
  const sel = new Set(chosen);
  return (
    <>
      <div className={`${b.sty} ${open ? b.open : ''}`} data-f="sty">
        <div className={b.ci}>
          <div className={b.sgb} id="devs-sgb" role="group" aria-label="Stage" data-f="sgb">
            {STAGES.map((s) => {
              const on = sel.has(s.key), c = ready ? counts[s.key] ?? 0 : null;
              return (
                <button key={s.key} type="button" data-fk={`st-${s.key}`} tabIndex={open ? 0 : -1} className={`${b.sg} ${on ? b.on : ''} ${c === 0 ? b.zero : ''}`} style={{ '--c': s.c, '--t': s.t, '--d': s.d }} aria-pressed={on}
                  aria-label={`${s.name}, ${fmt(c)} devs${on ? ', on, click to clear' : ''}`} title={`${s.name} · ${fmt(c)}${on ? ' · click to clear' : ''}`} onClick={() => onToggle(s.key)}>
                  <span className={b.sd} aria-hidden="true"><Ic n="chk" /></span><span className={b.nm}>{s.name}</span><span className={b.ct}>{fmt(c)}</span>
                </button>
              );
            })}
          </div>
        </div>
      </div>
      <span className={b.brk} aria-hidden="true" />
    </>
  );
}
